// extracted by mini-css-extract-plugin
module.exports = {"card":"Hero_card_1km31","actionBtn":"Hero_actionBtn_iPHRe"};